import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './ProductEditor.scss';
import BaseReactComponent from '../../Util/BaseReactComponent';
import baseComponent from '../../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import ProgressButton from '../../ProgressButton';
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/lib/Modal';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form, ValidatedInput } from 'react-bootstrap-validation';

@connect(state => ({
    user: state.login.user
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class ProductEditor extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.deleteMode = false;
        this.state.editMode = undefined;
    }

    onAddProduct(p) {
        if (p) {
            this.setState(p);
            this.setState({
                editMode: 'NEW'
            });

            this.state = p;
        }
    }

    editProduct(p) {
        if (p) {
            this.setState(p);
            this.setState({
                editMode: 'EDIT'
            });
            this.state = p;
        }
    }

    onProductDelete() {
        if (this.state.deleteMode) {
            this.props.disableProduct(this.state);

            this.setState({
                deleteMode: false
            });
        }
    }

    onProductAdd() {
        if (this.state.editMode === 'EDIT') {
            this.props.updateProduct(this.state);
        } else {
            this.props.addProduct(this.state);
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.product() !== undefined && nextProps.product().editMode === 'EDIT') {//|| this.variantsUpdated(nextProps)) {
            this.editProduct(this.props.product());
            this.props.product().editMode = undefined;
        } else if (nextProps.product() !== undefined && nextProps.product().editMode === 'NEW') {
            this.onAddProduct(nextProps.product());
            this.props.product().editMode = undefined;
        }
    }

    cancelEdit() {
        this.props.changeTab(4);
    }

    startDeleteMode() {
        this.setState({
            deleteMode: true
        });
    }

    stopDeleteMode() {
        this.setState({
            deleteMode: false
        });
    }

    handleChange(key, event) {
        let update = {};
        update[key] = event.currentTarget.value;
        this.setState(update);
    }

    handleTabsChange(value) {
        this.props.changeTab(value);
    }

    keyup(e) {
        if (e.which === 13) {
            this.onProductAdd(e);
        }
    }

    render() {
        let subTitle = this.getMessage(this.state.editMode === 'EDIT' ? 'edit-product' : 'add-product');

        let deleteField = (<div className="form-group">
            <label htmlFor="address" className="col-sm-2 control-label">{this.getMessage('delete-label')}</label>

            <div className="col-sm-6">
                <ProgressButton onClick={this.startDeleteMode.bind(this)} className="form-group">{this.getMessage('delete-label')}</ProgressButton>
            </div>
        </div>);

        return (
            <div className="ProductEditor">
                <div className="editor-header">
                    <div className="container">
                        <h1>{subTitle}</h1>
                    </div>
                </div>

                <Modal title="Delete user" onHide={this.stopDeleteMode.bind(this)} show={this.state.deleteMode}>
                    <Modal.Header>
                        {this.getMessage('delete-title')}
                    </Modal.Header>

                    <Modal.Body>
                        <p>
                            You are about to delete <b>{this.state.name}</b><br/>
                            Are you sure?
                        </p>
                    </Modal.Body>

                    <Modal.Footer>
                        <a className="btn btn-link" onClick={this.stopDeleteMode.bind(this)}>{this.getMessage('cancel-button')}</a>
                        <a className="btn btn-primary" onClick={this.onProductDelete.bind(this)}>{this.getMessage('delete-label')}</a>
                    </Modal.Footer>
                </Modal>

                <div className="container">
                    <Form role="form" className="form-horizontal" onKeyPress={this.keyup.bind(this)} onValidSubmit={this.onProductAdd.bind(this)}>
                        <div className="form-group">
                            <label htmlFor="username" className="col-sm-2 control-label">{this.getMessage('productID-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="productID"
                                                type="number"
                                                className="validate"
                                                id="productID"
                                                onChange={this.handleChange.bind(this, 'productID')}
                                                value={this.state.productID}
                                                validate="required"
                                                errorHelp={{
                                  required: 'Please enter an ID for this product'
                                }}
                                    />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('name-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="name"
                                                type="text"
                                                className="validate"
                                                id="name"
                                                onChange={this.handleChange.bind(this, 'name')}
                                                value={this.state.name}
                                                validate="required"
                                                errorHelp={{
                                  required: 'Please enter a name for this product'
                                }}
                                    />
                            </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('articlePrefix-label')}</label>

                          <div className="col-sm-6">
                            <ValidatedInput name="articlePrefix"
                                            type="text"
                                            className="validate"
                                            id="articlePrefix"
                                            onChange={this.handleChange.bind(this, 'articlePrefix')}
                                            value={this.state.articlePrefix}
                              />
                          </div>
                        </div>

                        {this.state.editMode === 'EDIT' ? deleteField : (<div></div>)}
                        <div className="controls">
                            <a className="btn btn-primary" onClick={this.onProductAdd.bind(this)}>{this.getMessage('save-button')}</a>
                            <a className="btn btn-link" onClick={this.cancelEdit.bind(this)}>{this.getMessage('cancel-button')}</a>
                        </div>
                    </Form>

                </div>
            </div>
        );
    }
}

ProductEditor.propTypes = {
    product: React.PropTypes.func,
    changeTab: React.PropTypes.func,
    updateProduct: React.PropTypes.func,
    addProduct: React.PropTypes.func,
    disableProduct: React.PropTypes.func
};

ProductEditor.defaultProps = {
    componentName: 'product-editor'
};

export default ProductEditor;



// WEBPACK FOOTER //
// /src/components/Product/ProductEditor/ProductEditor.js